import { useGetLabelColorsQuery } from './tickets.api';

// Global label -> colour-key map (lowercased label keys). One shared RTK Query
// cache entry; every chip reads from it so a recolour reflects everywhere.
export function useLabelColorMap(): Record<string, string> {
    const { data } = useGetLabelColorsQuery();
    return data ?? {};
}
